import z from 'zod';
export var DocumentDataSource;
(function (DocumentDataSource) {
    DocumentDataSource["Crossmark"] = "CROSSMARK";
    DocumentDataSource["DateSigned"] = "DATE_SIGNED";
    DocumentDataSource["EhrScheduled"] = "EHR_SCHEDULED";
    DocumentDataSource["EmergencyContactName"] = "EMERGENCY_CONTACT_NAME";
    DocumentDataSource["EmergencyContactRelationship"] = "EMERGENCY_CONTACT_RELATIONSHIP";
    DocumentDataSource["EmergencyContactPhone"] = "EMERGENCY_CONTACT_PHONE";
    DocumentDataSource["FreehandBodyDiagram"] = "FREEHAND_BODY_DIAGRAM";
    DocumentDataSource["GuardianRelationship"] = "GUARDIAN_RELATIONSHIP";
    DocumentDataSource["MRN"] = "MRN";
    DocumentDataSource["None"] = "NONE";
    DocumentDataSource["Signature"] = "SIGNATURE";
    DocumentDataSource["GuarantorAge"] = "GUARANTOR_AGE";
    DocumentDataSource["GuarantorDOB"] = "GUARANTOR_DOB";
    DocumentDataSource["GuarantorHomeAddress"] = "GUARANTOR_HOME_ADDRESS";
    DocumentDataSource["GuarantorHomeFullAddress"] = "GUARANTOR_HOME_FULL_ADDRESS";
    DocumentDataSource["GuarantorHomeCityStateZip"] = "GUARANTOR_HOME_CITY_STATE_ZIP";
    DocumentDataSource["GuarantorHomePhoneNumber"] = "GUARANTOR_HOME_PHONE_NUMBER";
    DocumentDataSource["GuarantorName"] = "GUARANTOR_NAME";
    DocumentDataSource["GuarantorRelationship"] = "GUARANTOR_RELATIONSHIP";
    DocumentDataSource["GuarantorRelationshipToPatient"] = "GUARANTOR_RELATIONSHIP_TO_PATIENT";
    DocumentDataSource["GuarantorSex"] = "GUARANTOR_SEX";
    DocumentDataSource["GuarantorSSN"] = "GUARANTOR_SSN";
    DocumentDataSource["PatientAge"] = "PATIENT_AGE";
    DocumentDataSource["NewbornAge"] = "NEWBORN_AGE";
    DocumentDataSource["PatientBirthGestationalAge"] = "PATIENT_BIRTH_GESTATIONAL_AGE";
    DocumentDataSource["PatientBirthWeightGrams"] = "PATIENT_BIRTH_WEIGHT_GRAMS";
    DocumentDataSource["PatientDOB"] = "PATIENT_DOB";
    DocumentDataSource["PatientEmail"] = "PATIENT_EMAIL";
    DocumentDataSource["PatientEmployer"] = "PATIENT_EMPLOYER";
    DocumentDataSource["PatientPreferredLanguage"] = "PATIENT_PREFERRED_LANGUAGE";
    DocumentDataSource["PatientHomeAddress"] = "PATIENT_HOME_ADDRESS";
    DocumentDataSource["PatientHomeFullAddress"] = "PATIENT_HOME_FULL_ADDRESS";
    DocumentDataSource["PatientHomeCityStateZip"] = "PATIENT_HOME_CITY_STATE_ZIP";
    DocumentDataSource["PatientHomePhoneNumber"] = "PATIENT_HOME_PHONE_NUMBER";
    DocumentDataSource["PatientInitials"] = "PATIENT_INITIALS";
    DocumentDataSource["PatientIP"] = "PATIENT_IP";
    DocumentDataSource["PatientMobilePhoneNumber"] = "PATIENT_MOBILE_PHONE_NUMBER";
    DocumentDataSource["PatientMotherName"] = "PATIENT_MOTHER_NAME";
    DocumentDataSource["PatientMRN"] = "PATIENT_MRN";
    DocumentDataSource["PatientAthenaIdxMrn"] = "PATIENT_ATHENA_IDX_MRN";
    DocumentDataSource["PatientName"] = "PATIENT_NAME";
    DocumentDataSource["PatientRace"] = "PATIENT_RACE";
    DocumentDataSource["PatientSex"] = "PATIENT_SEX";
    DocumentDataSource["PatientSSN"] = "PATIENT_SSN";
    DocumentDataSource["PatientPharmacyNameWithAddress"] = "PATIENT_PHARMACY_NAME_WITH_ADDRESS";
    DocumentDataSource["PatientPharmacyPhone"] = "PATIENT_PHARMACY_PHONE";
    DocumentDataSource["PrimaryInsuranceGroupNumber"] = "PRIMARY_INSURANCE_GROUP_NUMBER";
    DocumentDataSource["PrimaryInsuranceInsuranceName"] = "PRIMARY_INSURANCE_INSURANCE_NAME";
    DocumentDataSource["PrimaryInsurancePolicyHolderAge"] = "PRIMARY_INSURANCE_POLICY_HOLDER_AGE";
    DocumentDataSource["PrimaryInsurancePolicyHolderDOB"] = "PRIMARY_INSURANCE_POLICY_HOLDER_DOB";
    DocumentDataSource["PrimaryInsurancePolicyHolderHomeAddress"] = "PRIMARY_INSURANCE_POLICY_HOLDER_HOME_ADDRESS";
    DocumentDataSource["PrimaryInsurancePolicyHolderHomeCityStateZip"] = "PRIMARY_INSURANCE_POLICY_HOLDER_HOME_CITY_STATE_ZIP";
    DocumentDataSource["PrimaryInsurancePolicyHolderHomePhoneNumber"] = "PRIMARY_INSURANCE_POLICY_HOLDER_HOME_PHONE_NUMBER";
    DocumentDataSource["PrimaryInsurancePolicyHolderName"] = "PRIMARY_INSURANCE_POLICY_HOLDER_NAME";
    DocumentDataSource["PrimaryInsurancePolicyHolderRelationshipToPatient"] = "PRIMARY_INSURANCE_POLICY_HOLDER_RELATIONSHIP_TO_PATIENT";
    DocumentDataSource["PrimaryInsurancePolicyHolderSex"] = "PRIMARY_INSURANCE_POLICY_HOLDER_SEX";
    DocumentDataSource["PrimaryInsurancePolicyNumber"] = "PRIMARY_INSURANCE_POLICY_NUMBER";
    DocumentDataSource["PatientCareProviderAddress"] = "PATIENT_CARE_PROVIDER_ADDRESS";
    DocumentDataSource["PatientCareProviderName"] = "PATIENT_CARE_PROVIDER_NAME";
    DocumentDataSource["SecondaryInsuranceGroupNumber"] = "SECONDARY_INSURANCE_GROUP_NUMBER";
    DocumentDataSource["SecondaryInsuranceInsuranceName"] = "SECONDARY_INSURANCE_INSURANCE_NAME";
    DocumentDataSource["SecondaryInsurancePolicyHolderAge"] = "SECONDARY_INSURANCE_POLICY_HOLDER_AGE";
    DocumentDataSource["SecondaryInsurancePolicyHolderDOB"] = "SECONDARY_INSURANCE_POLICY_HOLDER_DOB";
    DocumentDataSource["SecondaryInsurancePolicyHolderHomeAddress"] = "SECONDARY_INSURANCE_POLICY_HOLDER_HOME_ADDRESS";
    DocumentDataSource["SecondaryInsurancePolicyHolderHomeCityStateZip"] = "SECONDARY_INSURANCE_POLICY_HOLDER_HOME_CITY_STATE_ZIP";
    DocumentDataSource["SecondaryInsurancePolicyHolderHomePhoneNumber"] = "SECONDARY_INSURANCE_POLICY_HOLDER_HOME_PHONE_NUMBER";
    DocumentDataSource["SecondaryInsurancePolicyHolderName"] = "SECONDARY_INSURANCE_POLICY_HOLDER_NAME";
    DocumentDataSource["SecondaryInsurancePolicyHolderRelationshipToPatient"] = "SECONDARY_INSURANCE_POLICY_HOLDER_RELATIONSHIP_TO_PATIENT";
    DocumentDataSource["SecondaryInsurancePolicyHolderSex"] = "SECONDARY_INSURANCE_POLICY_HOLDER_SEX";
    DocumentDataSource["SecondaryInsurancePolicyNumber"] = "SECONDARY_INSURANCE_POLICY_NUMBER";
    DocumentDataSource["VisitAdmitDate"] = "VISIT_ADMIT_DATE";
    DocumentDataSource["VisitAdmitDatetime"] = "VISIT_ADMIT_DATETIME";
    DocumentDataSource["VisitAdmittingPhysicianName"] = "VISIT_ADMITTING_PHYSICIAN_NAME";
    DocumentDataSource["VisitAttendingPhysicianName"] = "VISIT_ATTENDING_PHYSICIAN_NAME";
    DocumentDataSource["VisitBuildingLocation"] = "VISIT_BUILDING_LOCATION";
    DocumentDataSource["VisitEHRID"] = "VISIT_EHR_ID";
    DocumentDataSource["VisitEHRType"] = "VISIT_EHR_TYPE";
    DocumentDataSource["VisitMedicalService"] = "VISIT_MEDICAL_SERVICE";
    DocumentDataSource["VisitReason"] = "VISIT_REASON";
})(DocumentDataSource || (DocumentDataSource = {}));
export var DocumentFont;
(function (DocumentFont) {
    /**
     * @deprecated Helvetica has very limited char set support. And because it is pdf-lib built in font, unlike custom font, it throws errors instead of render "empty" char, cause document generation failure. Please use SignPainterHouseScript for signature style text and UbuntuR for normal text. {@see https://github.com/Hopding/pdf-lib#fonts-and-unicode}
     */
    DocumentFont["Helvetica"] = "Helvetica";
    DocumentFont["SignPainterHouseScript"] = "SignPainterHouseScript";
    DocumentFont["UbuntuR"] = "Ubuntu R";
})(DocumentFont || (DocumentFont = {}));
// LEFT_TOP ------- CENTER_TOP ------- RIGHT_TOP
// | | | | | | | | | | | | | | | | | | | | | | |
// LEFT_BOT ------- CENTER_BOT ------- RIGHT_BOT
export var DocumentPointReference;
(function (DocumentPointReference) {
    DocumentPointReference["LeftTop"] = "LEFT_TOP";
    DocumentPointReference["LeftBottom"] = "LEFT_BOTTOM";
    DocumentPointReference["RightTop"] = "RIGHT_TOP";
    DocumentPointReference["RightBottom"] = "RIGHT_BOTTOM";
})(DocumentPointReference || (DocumentPointReference = {}));
export const DocumentCommandSchema = z.object({
    dataSource: z.string(),
    font: z.enum(DocumentFont),
    fontSize: z.number(),
    fontColorR: z.number(), // 0-255,
    fontColorG: z.number(), // 0-255,
    fontColorB: z.number(), // 0-255,
    pageIndex: z.number(),
    // 0, 0 is bottom left of the PDF page
    pointX: z.number(),
    pointY: z.number(),
    pointRef: z.enum(DocumentPointReference),
    lineWidth: z.number().optional(),
    mappedValue: z.enum([DocumentDataSource.Crossmark, DocumentDataSource.None]).optional(),
    // TODO: previsitFormFieldId should be named previsitFormTemplateFieldConfigId, since it stores the id of a previsit_form_template_field_config.
    // Check https://app.asana.com/1/1187495389489253/project/1204809327547775/task/1208614006290678?focus=true
    previsitFormFieldId: z.string().optional(),
    value: z.string().optional(),
});
//# sourceMappingURL=render.js.map